import React, { useEffect, useState, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import _ from 'lodash';
import * as actions from '../action';
import * as c from '../constant';
import EditAdditionalItemsModal from '../modals/EditAdditionalItemsModal';

function AdditionalItemsContainer({
  getList,
  dataList,
  applicationId,
  isLoading,
  getFloorArea,
  floorAreaList,
  showData,
  dataInfo,
  ordinanceRevisionId,
  applicationInfo
}) {

  const [formData, setFormData] = useState({});
  const setModal = useContext(ModalContext);

  const handleEdit = e => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <EditAdditionalItemsModal
          buildingId={applicationId}
          dataList={dataList}
          dataInfo={dataInfo}
          floorAreaList={floorAreaList}
          buvAmount={formData.buv}
          ordinanceRevisionId={ordinanceRevisionId}
        />),
      title: 'Edit Additional Item',
      modalSize: 'modal-xl',
    });
  };

  const OnSetFormData = () => {
    if (dataList.length > 0 && +_.get(dataList, '0.attributes.rptax_building_application_id') === +applicationId) {
      setFormData({
        floor: _.get(dataList, '0.attributes.floor'),
        rptax_actual_use_id: _.get(dataList, '0.attributes.rptax_actual_use_id'),
        rptax_building_component_id: _.get(dataList, '0.attributes.rptax_building_component_id'),
        area: _.get(dataList, '0.attributes.area'),
        rate: _.get(dataList, '0.attributes.rate'),
        is_add_area: _.get(dataList, '0.attributes.rate'),
        buv: _.get(dataList, '0.included.buildingApplication.attributes.unit_construction_cost'),
      });
      showData(applicationId, _.get(dataList, '0.id'));
    }
  };

  useEffect(() => {
    if (!_.isEmpty(applicationId)) {
      getList(applicationId);
      getFloorArea(applicationId);
    }
  }, []);

  useEffect(() => {
    if (!_.isEmpty(applicationId)) {
      getList(applicationId);
      getFloorArea(applicationId);
    }
  }, [applicationId]);

  useEffect(() => {
    if (_.isEmpty(dataList)) {
      setFormData({});
    }
    if (!_.isEmpty(dataList)) {
      OnSetFormData();
    }
  }, [dataList]);

  return (
    <>
      {isLoading ? (
        <div className="loading">
          <div className="spinner text-center">
            <span className="fas fa-1x fa-spin fa-spinner" />
          </div>
        </div>
      ) : (
        <>
          <div className="row d-flex align-items-center mt-2">
            <div className="col py-3 ml-2">
              <span className="title-color">Additional Items</span>
            </div>
            {[
              'PENDING',
              'FOR APPRAISAL AND ASSESSMENT',
              'TRANSFERRED',
              'FOR REASSESSMENT',
            ].indexOf(_.get(applicationInfo, 'attributes.status')) > -1 &&
              (
                <div className="col py-0 m-0 d-flex">
                  <button
                    type="button"
                    onClick={handleEdit}
                    className="btn btn-primary cms-bg-color-primary cms-outline-primary font-weight-bold px-4 ml-auto mr-2"
                  >
                    <i className="fas fa-edit" /> Edit Additional Items
                  </button>
                </div>
              )};
          </div>
          <div className="row my-3 mx-2">
            <table className="css-table table table-borderless table-sm table-striped table-hover">
              <thead className="table-header">
                <tr>
                  <td className="font-weight-bold">Floor</td>
                  <td className="font-weight-bold">Actual Use</td>
                  <td className="font-weight-bold">Component</td>
                  <td className="font-weight-bold">Area</td>
                  <td className="font-weight-bold">Rate</td>
                  <td className="font-weight-bold">Added Area to Building Core?</td>
                </tr>
              </thead>
              <tbody>
                {_.isEmpty(dataList) ? (
                  <tr className="w-100">
                    <td colSpan="6" className="text-center border-top p-4 text-muted">
                      This Section is Empty
                    </td>
                  </tr>
                ) : (
                  dataList.map(item => (
                    <tr key={item.id}>
                      <td className="history-color">{_.get(item, 'attributes.floor')}</td>
                      <td className="history-color">{_.get(item, 'included.actualUse.attributes.description') || ''}</td>
                      <td className="history-color">{_.get(item, 'included.buildingComponent.attributes.name') || ''}</td>
                      <td className="history-color">{_.get(item, 'attributes.area') || ''}</td>
                      <td className="history-color">PHP{' '}{_.get(item, 'attributes.rate') || ''}</td>
                      <td className="history-color">{_.get(item, 'attributes.is_add_area') === 1 ? 'Yes' : 'No' || ''}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </>
      )}
    </>
  );
}

AdditionalItemsContainer.defaultProps = {
  applicationId: '',
  ordinanceRevisionId: '',
  applicationInfo: {}
};

AdditionalItemsContainer.propTypes = {
  getList: PropTypes.instanceOf(Function).isRequired,
  dataList: PropTypes.instanceOf(Array).isRequired,
  applicationId: PropTypes.string,
  isLoading: PropTypes.bool.isRequired,
  getFloorArea: PropTypes.instanceOf(Function).isRequired,
  floorAreaList: PropTypes.instanceOf(Array).isRequired,
  dataInfo: PropTypes.instanceOf(Object).isRequired,
  applicationInfo: PropTypes.instanceOf(Object),
  showData: PropTypes.instanceOf(Function).isRequired,
  ordinanceRevisionId: PropTypes.string,
};

const mapStateToProps = ({ api }) => ({
  dataList: _.get(api, `${c.GET_ADDITIONAL_ITEMS_LIST}.list`) || [],
  floorAreaList: _.get(api, `${c.GET_FLOOR_AREA}.list`) || [],
  isLoading: _.get(api, 'loading', []).indexOf(c.GET_ADDITIONAL_ITEMS_LIST) > -1,
  dataInfo: _.get(api, `${c.SHOW_ADDITIONAL_ITEMS_DATA}.item`) || {},
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(AdditionalItemsContainer);
